<template>
    <div class="page-set-customDoc">
        <div class="pg-breadcrumb">
            <div class="breadcrumb-item em">後臺設置</div>
            <div class="breadcrumb-item">品名管理</div>
        </div>

        <div class="card-block">
            <Form inline class="pg-form-inline form-input-wrap">
                <FormItem>
                    <Upload :before-upload="handleBeforeUpload"
                            accept=".xls, xlsx, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                            :format="['xlsx', 'xls']"
                            action="">
                        <div class="upload-file">
                            <template>
                                <span v-if="uploadFile.file && uploadFile.file.name">{{uploadFile.file.name}}</span>
                                <span v-else>Excel (xls, xlsx, csv) 表格</span>
                            </template>
                            <span class="upload-btn">選擇</span>
                        </div>
                    </Upload>
                </FormItem>
                <FormItem>
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleUplodFile">導入excel</div>
                    </div>
                </FormItem>
            </Form>
        </div>

        <div class="card-block pd-bt">
            <Spin fix class="pg-sub-loading" v-if="isLoading">
                <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
                <div class="loading-text">Loading</div>
            </Spin>

            <div class="pg-form-wrap">
                <Form :label-width="150">
                    <Row>
                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>品名</span>
                                </div>
                                <Input placeholder="請輸入中文字" v-model="form.name"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>HS編碼</span>
                                </div>
                                <Input placeholder="請輸入數字" v-model="form.code"/>
                            </FormItem>
                        </Col>

                        <Col span="11">
                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>商品貨號</span>
                                </div>
                                <Input placeholder="請輸入數字" v-model="form.number"/>
                            </FormItem>

                            <FormItem>
                                <div slot="label" class="form-label">
                                    <em class="red">* </em>
                                    <span>拼音</span>
                                </div>
                                <Input placeholder="請輸入文字" v-model="form.pinyin"/>
                            </FormItem>
                        </Col>
                    </Row>

                    <FormItem>
                        <div class="pg-btn-wrap pg-form-btn">
                            <div class="pg-btn style1" @click="handleCheckForm">添加</div>
                            <!-- <Button type="error" :loading="true" class="loading-btn">
                                 <span>Loading...</span>
                             </Button>-->
                        </div>
                    </FormItem>
                </Form>
            </div>

            <Table size="small"
                   border
                   no-data-text="暫無數據"
                   :columns="table.column"
                   :data="table.data">
                <template slot-scope="{ row, index }" slot="action">
                    <div class="pg-btn-wrap">
                        <div class="pg-btn style2" @click="handleEdit(index)">修改</div>
                        <div class="pg-btn style1" @click="handleDelete(index)">刪除</div>
                    </div>
                </template>
            </Table>

            <div class="pg-pagger">
                <Row>
                    <Col span="11" class="pagger-left">
                        <div class="pagger-total">總共{{totalCount}}條記錄</div>
                    </Col>
                    <Col span="13" class="pagger-right">
                        <!-- v-if="totalCount > curPageSize" -->
                        <div>
                            <div class="pagger-sizer">
                                <span>每頁</span>
                                <Select v-model="curPageSize" size="small" placeholder="數量"
                                        @on-change="handlePageSizeChange">
                                    <Option :value="10">10</Option>
                                    <Option :value="20">20</Option>
                                    <Option :value="30">30</Option>
                                    <Option :value="40">40</Option>
                                    <Option :value="50">50</Option>
                                </Select>
                            </div>

                            <div class="pagger-elevator">
                                <span>跳轉</span>
                                <Input size="small" v-model="pageInput" @on-keyup="handlePageInput"
                                       @on-enter="handlePageEnter"/>
                            </div>

                            <Page size="small"
                                  :current="pageIndex"
                                  :page-size="curPageSize"
                                  :total="totalCount"
                                  @on-change="handlePageChange">
                            </Page>
                        </div>
                    </Col>
                </Row>
            </div>

        </div>

    </div>
</template>

<script>
    export default {
        data()
        {
            return {
                pageIndex: 1,   //页码
                curPageSize: 10,    //一页数量
                totalCount: 1, //总条数
                pageInput: '',  //输入的页码

                //上传
                uploadFile: {
                    file: ''
                },

                form: {
                    name: '', //品名
                    code: '', //HS编码
                    number: '',   //货号
                    pinyin: '',  //规格
                },
                isLoading: true,
                table: {
                    column: [
                        {
                            title: '品名',
                            key: 'name',
                            align: 'center',
							sortable: true,
                            width: 150
                        },
                        {
                            title: 'HS編碼',
                            key: 'code',
                            align: 'center',
							sortable: true,
                        },
                        {
                            title: '商品貨號',
                            key: 'number',
                            align: 'center',
							sortable: true,
                        },
                        {
                            title: '拼音',
                            key: 'pinyin',
                            align: 'center',
							sortable: true,
                        },
                        {
                            title: '操作',
                            slot: 'action',
                            align: 'center',
                            width: 150
                        }
                    ],
                    data: []
                }
            };
        },
        activated()
        {
            this.getList();
        },
        mounted()
        {
            this.getList();
        },
        methods: {
            //上传
            handleBeforeUpload(file)
            {
                this.uploadFile.file = file;
                return false;
            },

            handleUplodFile()
            {
                let uploadFile = this.uploadFile;

                if (uploadFile.file == '')
                {
                    this.$Utils.showTipInfo('请选择文件');
                    return;
                }

                let formData = new FormData();
                formData.append('file', uploadFile.file);

                this.$Rq.requestAuth({
                    url: this.$Api.customDocUpload,
                    method: 'post',
                    data: formData,
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    }
                }).then((res) =>
                {
                    if (res.code == 0)
                    {
                        this.$Utils.showSuccess('导入成功');
                        this.uploadFile = {
                            file: ''
                        };

                        this.pageIndex = 1;
                        this.getList();

                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) => {});
            },

            getList()
            {
                let form = this.form;

                this.isLoading = true;
                this.$Rq.requestAuth({
                    url: this.$Api.customDocList,
                    method: 'get',
                    data: {
                        offset: (this.pageIndex - 1) * this.curPageSize,
                        limit: this.curPageSize
                    }
                }).then((res) =>
                {
                    this.isLoading = false;
                    if (res.code == 0)
                    {
                        let tempArr = [];
                        let resData = res.data.data;

                        for (let i = 0; i < resData.length; i++)
                        {
                            tempArr.push({
                                id: resData[i].id,
                                name: resData[i].name,
                                code: resData[i].code,
                                number: resData[i].number,
                                pinyin: resData[i].pinyin
                            });
                        }

                        this.totalCount = res.data.count;
                        this.table.data = tempArr;
                    }
                }).catch(() =>
                {
                    this.isLoading = false;
                });
            },

            handleCheckForm()
            {
                let form = this.form;
                if (form.name === '')
                {
                    this.$Utils.showTipInfo('請輸入品名');
                    return;
                } else if (form.number === '')
                {
                    this.$Utils.showTipInfo('請輸入商品貨號');
                    return;
                } else if (form.code === '')
                {
                    this.$Utils.showTipInfo('請输入HS编码');
                    return;
                } else if (form.pinyin === '')
                {
                    this.$Utils.showTipInfo('請输入拼音');
                    return;
                }

                this.handleSubmit();
            },

            handleSubmit()
            {
                let form = this.form;
                this.isSubmiting = true;

                this.$Rq.requestAuth({
                    url: this.$Api.customDocAdd,
                    method: 'post',
                    data: {
                        name: form.name, //品名
                        code: form.code, //HS编码
                        number: form.number,   //货号
                        pinyin: form.pinyin,  //规格
                    }
                }).then((res) =>
                {
                    this.isSubmiting = false;

                    if (res.code == 0)
                    {
                        this.$Utils.showTipInfo(res.msg);
                        this.form = {
                            name: '', //品名
                            code: '', //HS编码
                            number: '',   //货号
                            pinyin: '',  //规格
                        };

                        this.getList();
                    } else
                    {
                        this.$Utils.showTipInfo(res.msg);
                    }
                }).catch((err) =>
                {
                    this.isSubmiting = false;
                });
            },

            handleEdit(index)
            {
                let tableData = this.table.data;
                this.$router.push({path: '/setCustomDocEdit?id=' + tableData[index].id});
            },

            handleDelete(index)
            {
                this.$Modal.confirm({
                    title: '提示',
                    content: '確定刪除嗎？',
                    cancelText: '取消',
                    okText: '確定',
                    onOk: () =>
                    {
                        let tableData = this.table.data;
                        this.isSubmiting = true;

                        this.$Rq.requestAuth({
                            url: this.$Api.customDocDelete + '/' + tableData[index].id,
                            method: 'delete'
                        }).then((res) =>
                        {
                            this.isSubmiting = false;

                            if (res.code == 0)
                            {
                                this.$Utils.showSuccess(res.msg);

                                if (tableData.length <= 1 && this.pageIndex > 1)
                                {
                                    this.pageIndex -= 1;
                                }
                                this.getList();

                            } else
                            {
                                this.$Utils.showTipInfo(res.msg);
                            }
                        }).catch((err) =>
                        {
                            this.isSubmiting = false;
                        });

                    }
                });
            },

            //pager
            handlePageSizeChange(value)
            {
                this.pageIndex = 1;
                this.getList();
            },

            handlePageInput()
            {
                let value = ('' + this.pageInput).replace(/\D/g, '');
                let pageCount = Math.ceil(this.totalCount / this.curPageSize);
                if (value > pageCount)
                {
                    value = pageCount;
                }
                this.pageInput = value;
            },
            handlePageEnter()
            {
                if (this.pageInput == '' || this.pageInput == this.pageIndex) return;
                if (this.pageInput == 0)
                {
                    this.pageInput = 1;
                }
                this.pageInput = parseInt(this.pageInput);
                this.pageIndex = this.pageInput;
                this.getList();
            },

            handlePageChange(value)
            {
                this.pageIndex = value;
                this.getList();
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import 'SetCustomDoc.scss';
</style>